import {useMemo} from 'react'
import useMultiSite from './use-multi-site'
import {useCurrentCustomer} from './use-current-customer'
import useOcapiSite from './useOcapiSite'
import {isContentOnlySite} from '../utils/site-utils'

/*
 * Generates useful information about commerce sites.
 * @param {object} product - product to be able to view/process
 */
export const useCommerceData = (product) => {
    const {locale, site} = useMultiSite()
    const {data} = useCurrentCustomer()
    const {contentOnlySiteShowPrices, siteType} = useOcapiSite()
    const contentOnlySite = isContentOnlySite({siteType: siteType || site?.siteType})

    // Customer data is only available on client site and after loading it, so it’ll change after several seconds.
    // This implementation is fine for internal testing, but in general it should be changed.
    return useMemo(
        () => ({
            isEcommerceEnabled: !contentOnlySite || data?.isProductionTestingTeamCustomer,
            showPricesOnContentOnly:
                (!contentOnlySite || contentOnlySiteShowPrices?.includes(locale?.id)) &&
                !!product?.price
        }),
        [
            contentOnlySite,
            data?.isProductionTestingTeamCustomer,
            contentOnlySiteShowPrices,
            locale?.id,
            product?.price
        ]
    )
}
